{
  "en": {
    "project": {
      "actions": {
        "activate": "Activate",
        "addProjectMaintainer": "Add project maintainer",
        "add_as_partner": "Add as partner",
        "add_as_partner_description": "Are you sure you want to add {partner} as a partner to this project?",
        "add_project_partner": "Add project partner",
        "additional_information": "Additional information",
        "changeProjectLogin": "Change project image",
        "changeProjectLogo": "Change project logo",
        "deactivate": "Deactivate",
        "edit": "Edit",
        "finishRequest": "Send request",
        "follow": "Follow",
        "giveAccess": "Give access",
        "maintainerAdd": "Add project maintainer",
        "maintainerAddDescription": "Are you sure you want to grant {maintainer} access to this project?",
        "maintainerRemove": "Remove project maintainer",
        "maintainerRemoveDescription": "Are you sure you want to revoke access to this project for {maintainer}?",
        "new": "Project",
        "next": "Next",
        "remove_partner": "Remove {partner}",
        "remove_project_partner": "Remove project partner",
        "remove_project_partner_description": "Are you sure you want to remove {partner} from project partners?",
        "selectOption": "Select option",
        "selectTemplate": "Select Template",
        "submit": "Create project",
        "unFollow": "Unfollow"
      },
      "attributes": {
        "address": "Address",
        "currency": "Currency",
        "delivery_date_actual": "Expected end date",
        "delivery_date_contractual": "Contractual end date",
        "description": "Description",
        "internal_note": "Project internal note",
        "measurement": "Measurement Unit",
        "name": "Name",
        "picture_login_url": "Project Image",
        "picture_logo_url": "Project Logo",
        "quotity_total": "Total transfer amount",
        "skip_building": "Hide building",
        "skip_lot": "Hide plot",
        "skip_phase": "Hide phase",
        "skip_unit": "Hide unit (single-unit project)",
        "start_date": "Start date",
        "units_count": "Number of created units",
        "units_count_max": "Maximum number of units",
        "vat_percentage": "VAT %",
        "website_url": "Website URL"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Capacity reached, please get in touch with us."
        }
      },
      "import": {
        "add": "+ Add",
        "add_instead": "I actually want to add {levels}",
        "building": "building",
        "buildings": "buildings",
        "changed_mind": "Skip this level",
        "create_new": "What is the name of the {type}",
        "download_template": "Download import template",
        "drop_or_upload": "Drop the template here or click to upload",
        "error_line": "Error on line",
        "fill_space_info": "Fill in template with space information",
        "fill_unit_info": "Fill in template with unit information",
        "fix_file_upload": "Please fix the issues and upload the file again.</br>Existing units will not be removed, but will be updated if anything changed in the file for that unit since last upload.",
        "fix_file_upload_space": "Please fix the issues and upload the file again.</br>Existing spaces will not be removed, but will be updated if anything changed in the file for that space since last upload.",
        "for": "for",
        "import_column_title": "Do you want to add {column_type}?",
        "import_partial_success": "Import partially succeeded. Below are the remaining errors:",
        "import_spaces": "Import spaces",
        "import_units": "Import units for",
        "lot": "lot",
        "lots": "lots",
        "no": "no",
        "noLevels": "No {levels}",
        "phase": "phase",
        "phases": "phases",
        "plot": "lot",
        "select_level_above": "Select a {level} to continue",
        "start_upload": "Start upload",
        "step": "Step",
        "unit_info": "You will be able to import units once the project has been created",
        "unit_limit": "You want to import more units than you are allowed to. Please remove {exceeded_by} unit(s) or ask us to increase your number of allowed units",
        "units": "units",
        "upload_filled_template": "Upload filled in template",
        "upload_new_file": "Upload new file",
        "upload_spaces": "Upload spaces",
        "upload_units": "Upload units",
        "uploaded_file": "Uploaded file",
        "validations_failed": "Some validations failed",
        "yes": "yes"
      },
      "labels": {
        "activate": "Activeer project",
        "checkLevels": "Check the levels you'd like to add:",
        "companyInfo": "Company info",
        "companyNameTitle": "Company name",
        "congratulationsNewProject": "Congratulations on your new project",
        "copyFromTemplate": "Copiar do projeto modelo (opcional)",
        "customer_can_create_issue": "Customer can create snag",
        "customersCanLogIn": "Customers for this project can log in with",
        "deactivate": "Deactiveer project",
        "deactivated": "Deactivated",
        "download_export": "Download my export",
        "downloading_export": "Downloading",
        "endsOn": "Ends on the {enddate}",
        "export_expiration": "Your export data is ready to download. It will stay available until {time}",
        "export_explanation": "Request an export of all your data, including conversations and documents.",
        "export_failed": "Export failed",
        "export_file": "Export my file",
        "export_notification_snack": "Collecting your file can take up to a few minutes. You'll receive a notification when it's ready to download.",
        "export_prepared": "Your export data will be ready to download shortly.",
        "export_preparing": "Preparing export",
        "filterProject": "Select a project",
        "finalSteps": "Final steps",
        "follow": "Follow {project} to receive notifications.",
        "followedProjects": "My Projects",
        "following": "Following",
        "general": "General",
        "importContacts": "Yes, I would like to import customer contacts",
        "importInformationSubtitle": "Instead of adding spaces and contacts one by one, we can help you with importing a CSV file. Check the boxes below and a Ziggu team member will contact you.",
        "importInformationTitle": "Import information?",
        "importSpaces": "Yes, I would like to import parking and storage spaces",
        "importUnits": "Yes, I would like to import units and their information",
        "included": "Included",
        "internal": "Internal",
        "invoice_subtitle": "We will only send out an invoice if necessary, e.g. when you have no units left in your package.",
        "invoice_title": "To which email address can we send our invoices?",
        "isTemplateProject": "This is a template project",
        "levelBuildingExplainer": "Select this if you have multiple units inside one or more buildings.",
        "levelPhaseExplainer": "Select this if your project is built in different phases, spread over time.",
        "levelPlotExplainer": "Select this if your project consists of multiple parcels of land.",
        "levelProjectExplainer": "Your project is the biggest building block and is essential to get started.",
        "levelUnitExplainer": "The unit is the smallest building block. This is the house or apartment you are building for your customers.",
        "levels": "Project Structure",
        "limitReached": "Project limit reached",
        "multiUnits": "Multiple units",
        "nameTitle": "The name of the project?",
        "newProjectTitle": "Vamos criar o seu novo projeto!",
        "noAccess": "You don't have access to this project",
        "noFollowedProjects": "Click on the notification icon to follow a project.",
        "noProjects": "No projects found.",
        "optional_information": "Optional information",
        "optional_information_subtitle": "Is there anything else you would like to share with us?",
        "otherProjects": "Other Projects",
        "outOfProjects": "Seems like your package has run out of active projects.",
        "outOfProjectsContact": "Contact Ziggu to increase your package and continue creating projects.",
        "partner_invitation_notice": "{partner} has not been invited yet. An invitation will be sent when {partner} gets added to the project partners.",
        "pendingProjects": "{first_project_name} has been requested and is currently being set up by Ziggu | {count} projects have been requested and are currently being set up by Ziggu",
        "permission_partner_project": "A partner to easily share documents and proposals with",
        "permissionsOwnerOnly": "Only team members with role Owner can add new Project Maintainers",
        "permissionsRoleMaintainer": "A team member with access to this project",
        "project": "Project {project}",
        "projectBranding": "Project branding",
        "projectIsDeactivated": "This project is deactivated",
        "projectMaintainers": "Project Maintainers",
        "projectName": "Project name",
        "projectStructure": "Project structure",
        "projectStructureSubtitle": "You now have the possibility to add 3 extra levels to better organise your units.</br>Lets go through each of them, step by step.",
        "projectStructureSubtitleOld": "The project structure is defined once at the start of the project",
        "project_label": "Project",
        "project_partners": "Project Partners",
        "projects": "Projects",
        "remove_project_partner_prohibited": "{partner} is added to decisions in this project and cannot be removed from project partners.",
        "remove_project_partner_prohibited_label": "Project partner can't be removed",
        "searchProject": "Search project",
        "searchProjects": "Search project",
        "selectATemplateProject": "Select a template project",
        "selected": "Selected",
        "showProject": "Show Project",
        "singleUnit": "Single unit",
        "spaces": "Spaces",
        "startsOn": "Starts on the {startdate}",
        "step1Info": "Let's go over some details to get you started.",
        "step1Title": "Congrats on your new project!",
        "step2Info": "To which company can we address the invoice?",
        "step2Title": "Invoicing details",
        "step3Title": "Intermediate levels necessary?",
        "step4Info": "What happens next? Ziggu will set up {project} within 3 to 5 working days. You will be notified once everything is ready.",
        "templateProjects": "Template Projects",
        "unFollow": "No longer receive notifications for {project}.",
        "underConstruction": "Under construction",
        "units": "Units",
        "unitsActiveRemaining": "AVAILABLE UNITS",
        "unitsAllotted": "UNITS ALLOTTED",
        "unitsCountSubtitle": "How many units?",
        "unselected": "Click to select",
        "youAreEditingTemplateProject": "You are editing a template project",
        "you_have_inbound_emails": "You have 1 unprocessed inbound email | You have {number} unprocessed inbound emails"
      },
      "messages": {
        "units_count_max": "If you would like to create more units, please contact us through the chat button."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Let's set up your new project!"
          },
          "step_2": {
            "title": "Does this project contain one or more units"
          },
          "step_3": {
            "subtitle": "Click on the cards to activate the intermediate levels.",
            "title": "Need intermediate levels?"
          },
          "step_4": {
            "info": "Decision and Survey templates can be imported once the units are created for this project.",
            "placeholder": "Select a project or leave this empty if you don't want to copy from a template",
            "title": "Use a template as a basis?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Back to projects"
      },
      "notifications": {
        "emailHasBeenCopied": "Email address copied",
        "pictureChangedSuccessfully": "The picture has been updated. The changes could take up to one hour to be visible.",
        "tokenCopied": "Token copied successfully",
        "urlHasBeenCopied": "Url copied successfully"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "You do not have access to any projects. Ask a team member with Owner role to grant you access.",
            "title": "No projects"
          }
        },
        "partners": {
          "noProjectSubtitle": "You will be notified once a new project will be assigned to you",
          "noProjectTitle": "No project yet"
        }
      },
      "snackbars": {
        "duplicate": "The copying process has started and might take a few moments. Please refresh the page after a couple of minutes."
      },
      "toasts": {
        "activateSuccess": "{project_name} has been successfully activated.",
        "deactivateSuccess": "{project_name} has been successfully deactivated.",
        "duplicate": "Het project is gemaakt, maar het kopiëren van de sjabloon kan enkele minuten duren."
      },
      "tooltip": {
        "hasNoActiveUnits": "Has no active units",
        "turnOffNotifications": "Turn off notifications for {project}",
        "turnOnNotifications": "Turn on notifications for {project}"
      },
      "validation": {
        "addressInformationRequired": "Address information required",
        "companyNeedName": "Company name required",
        "companyNeedVatNumber": "VAT number required",
        "dateAfter": "Date must be after start date",
        "lessThanOrEqual": "Number has to be less than or equal to {max_number}",
        "maxLength": "Name can be maximum {length} characters",
        "nameAlreadyTaken": "Name is already taken for this project",
        "needName": "Title required",
        "needNumber": "Must be a number (e.g. 850)",
        "needUnitsCount": "Units count is required"
      }
    }
  }
}
